import { useApi } from '../classes/appApi'
import { useOffline } from '../components/App/AppOfflineContext'
import { useRouterContext } from '../components/App/AppRouter'
import MainLayout, { useMainLayoutContext } from '../components/MainLayout'
import TrainingRecordStatus from '../components/TrainingRecordStatus'
import { TrainingRecordSummaryModel } from '../defs/defs'
import EqxError from '../shared/components/EqxError'
import { EqxLink } from '@equinoxx/react'
import EqxListGroup, { EqxListGroupItem } from '../shared/components/EqxListGroup/EqxListGroup'
import EqxLoading from '../shared/components/EqxLoading'
import EqxRequestHandler from '../shared/components/EqxRequestHandler/EqxRequestHandler'
import useApiEndpoint from '../shared/hooks/ApiEndpoint'
import { formatDate } from '../shared/utils/formatDate'

// Main content component extracted from PageTrainingRecordIndex
const TrainingRecordIndexContent = () => {
    const api = useApi()
    const { response: records, loading, error } = useApiEndpoint<TrainingRecordSummaryModel[]>(api, api.endpoints.trainingRecords())
    const router = useRouterContext()
    const { isOffline, isFileCached } = useOffline()

    const mainContext = useMainLayoutContext()
    if (!mainContext.user?.staffID) {
        if (!mainContext.user) {
            return <EqxLoading />
        } else {
            return <EqxError error="Only staff can view training records" />;
        }
    }

    return (
        <EqxRequestHandler
            state={{ loading, error: error ?? null }}
            isEmpty={records?.length === 0}
            empty={<div className="p-5 text-center text-muted">No training records found</div>}
        >
            <EqxListGroup>
                {records?.map((record) => (
                    <EqxListGroupItem key={record.id}>
                        <div className="clickable d-flex" onClick={() => router.navigate(`/training-records/${record.id}`)}>
                            <div className="flex-grow-1">
                                <h6 className="mb-0"><EqxLink to={`/training-records/${record.id}`} className={isOffline && !isFileCached(`/training-records/${record.id}`) ? 'unavailable' : ''}>{record.name}</EqxLink></h6>
                                <div className="small text-muted">
                                    {record.issuer}
                                </div>
                            </div>
                            <div className="ms-3">
                                <TrainingRecordStatus record={record} />
                                <div className="small text-muted text-end">
                                    {record.date && formatDate(record.date)}
                                    {record.expiryDate && <> (Expires {formatDate(record.expiryDate)})</>}
                                </div>
                            </div>
                        </div>
                    </EqxListGroupItem>
                ))}
            </EqxListGroup>
        </EqxRequestHandler>
    )
}

const PageTrainingRecordIndex = () => {
    return (
        <MainLayout pageTitle="Training Records">
            <TrainingRecordIndexContent />
        </MainLayout>
    )
}

export default PageTrainingRecordIndex 